import React from 'react';
import { letterPatterns } from '../../utils/legoPatterns';
import { getStudScale, STUD_PX } from '../../utils/legoLayout';
import { LegoSize } from '../../types/LegoTypes';
import './LegoBuilder.css';

interface LegoLetterProps {
  letter: string;
  size: LegoSize;
  columnOffset: number;
  rowOffset: number;
}

export const LegoLetter: React.FC<LegoLetterProps> = ({
  letter,
  size,
  columnOffset,
  rowOffset,
}) => {
  const pattern = letterPatterns[letter.toUpperCase()];
  if (!pattern) return null;

  const studScale = getStudScale(size);
  const brickStuds = studScale * STUD_PX;

  return (
    <>
      {pattern.pixels.map((row, y) =>
        row.map(
          (isActive, x) =>
            isActive && (
              <div
                key={`${letter}-${x}-${y}`}
                className={`lego-brick-top size-${size.toLowerCase()}`}
                style={{
                  backgroundColor: `var(--lego-${pattern.color})`,
                  width: `${brickStuds}px`,
                  height: `${brickStuds}px`,
                  left: `${(columnOffset + x * studScale) * STUD_PX}px`,
                  top: `${(rowOffset + y * studScale) * STUD_PX}px`,
                }}
              >
                <div
                  className='brick-studs-grid'
                  style={{
                    gridTemplateColumns: `repeat(${studScale}, 1fr)`,
                    gridTemplateRows: `repeat(${studScale}, 1fr)`,
                  }}
                >
                  {Array.from({ length: studScale * studScale }, (_, i) => (
                    <div key={i} className='brick-stud' />
                  ))}
                </div>
              </div>
            ),
        ),
      )}
    </>
  );
};
